export class FontDescription
{
  fontName:string;
  weight:number;
  italic:boolean;
}
